import { redirect } from "react-router-dom";
import { AuthError } from "@/types/errorTypes/authError";
import { apiEndpoints } from "@/services/api/api.ts";
import { AdminPanelTagCreateData } from "@/routes/adminPanel/tags/create/types/adminPanelTagCreateData.ts";

export const adminPanelTagCreateAction = async ({
  request,
}: {
  request: Request;
}) => {
  const formData = await request.formData();
  const data = Object.fromEntries(
    formData,
  ) as unknown as AdminPanelTagCreateData;
  try {
    const url = new URL(request.url);
    const returnUrl = url.searchParams.get("returnUrl") || "/admin-panel/tags";

    const tagUpdateResult = await apiEndpoints.createTag(data);
    if (tagUpdateResult.success) {
      return redirect(returnUrl);
    }
    return true;
  } catch (err) {
    throw err;
  }
};
